import React, { Component } from "react"
import axios from "axios"
import { connect } from 'react-redux'
import { AppState } from "src/store"
import store from "src/store/store"
import { shouldAllowAccess } from "../../../utilities/helper"
import { Tabs, Tab, Popover, FormControl, OverlayTrigger, Tooltip } from "react-bootstrap"
import AxiosConfig from "../../../utilities/AxiosConfig"
import UserAdmin from "./UserAdmin/UserAdmin"
import EmployeeDataTypes from "../Types/EmployeeTypes"
import PhotoUploader from "../../../utilities/uploadService/PhotoUploader"
import employeeBackground from "../../../utilities/EmployeeBG"
import reggie from "../../../utilities/Reggie"
import WorkersComp from "./WorkersComp/WorkersComp"
import Naggy from "../../../utilities/naggy/Naggy"
import FieldFinder from "../../../utilities/FindField/FindField";
import ManageDetail from "../../pto/ManageDetail"
import moment from "moment"
import Reviews from "./Reviews/Reviews/Reviews"
import PTODecoupler from "src/pages/pto/decouplers/PTODecoupler/PTODecoupler"
import WorkCompTypes from "../Types/WorkCompTypes"
import secureSession from "../SecureSession"
import historySession from "../historySession"
import snackBar from "src/utilities/snackBar/SnackBar"
import UserReferenceTypes from "src/store/UserReference/types"
import TaskManager from "src/utilities/TaskManager/TaskManager"
import UnalignedHandler from "./UnalignedHandler"
import EALA from "src/components/eala/EALA"
import RoleAssignment from "./RoleAssignment/RoleAssignment"
import Training from "./Training/Training"
import EOTabTitle from "./EOTabTitle/EOTabTitle"
import "./EmployeeOverview.css"

interface EOProps {
    closeDetailPanel: Function
    setActiveKey: Function
    setHeaderType: Function
    setViewMode: Function
    updateList?: Function
    employee: EmployeeDataTypes
    activeKey: string
    userId: any
    headerType: string
    viewMode: string
    userReference: UserReferenceTypes
    singleDetail?: string
    doublePanelRef?: any
}

type EOTypes = {
    badgePic: null | string
    qrPic: null | string
    workComp: Array<WorkCompTypes>
    openClaims: number
    hasEdits: boolean
    employee: EmployeeDataTypes | object
    detailedEmployeeData: EmployeeDataTypes | object
    showLinkPopover: boolean
    activeTab: string
    editBadge: boolean
    headerExpanded: string
    viewMode: string
    ledgerEntryTypes: { id: number, text: string } | any
    ptoData: any
    tabInfo: { WorkCompCount: number, EmployeeReviewCount: number }
}

class EmployeeOverview extends Component<EOProps, EOTypes> {

    discardMsg = "Discard Changes?"
    adminTitle = "User Administration"
    date = new Date();
    timeZoneOffset = -this.date.getTimezoneOffset()

    constructor(props: EOProps) {
        super(props)
        this.state = {
            badgePic: null,
            editBadge: false,
            qrPic: null,
            workComp: [],
            openClaims: 0,
            hasEdits: false,
            employee: {},
            detailedEmployeeData: {},
            showLinkPopover: false,
            activeTab: "",
            headerExpanded: "HeaderExpanded",
            viewMode: "EmployeeOverviewFS",
            ledgerEntryTypes: [],
            ptoData: null,
            tabInfo: { WorkCompCount: 0, EmployeeReviewCount: 0 },
        }
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        UnalignedHandler.kill()
        UnalignedHandler.init(this.props.employee.UserId, this.props.employee.UserId)
        if (!this.props.singleDetail) {
            window.stop()
        }
        // this.getQR()
        // this.getBadgePic()
        this.getEmployeeData()
        if (shouldAllowAccess("HR:PTO")) {
            this.getPtOData()
        }
        if (shouldAllowAccess("HR:FORMWRITER")) {
            this.getWorkCompIncidents()
        }
        if (!this.props.singleDetail) {
            this.setState({ headerExpanded: this.props.headerType, viewMode: this.props.viewMode })
        } else {
            this.setState({ headerExpanded: this.props.headerType })
            this.adminTitle = "My Info"
        }
        if (!this.props.userReference) {
            this.getUserReference()
        }
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        secureSession.cancel()
        historySession.cancel()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        secureSession.cancel()
        historySession.cancel()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }

    handleResize() {
        if (window.innerWidth < 830 && this.state.headerExpanded === "HeaderExpanded") {
            this.manageState([{ key: "headerExpanded", value: "HeaderCollapsed" }])
        }
    }

    handleTabSelect = (key: any) => {
        this.props.setActiveKey(key)
    }

    getUserReference = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/reference", AxiosConfig.configValue())
            .then(res => {
                localStorage.setItem("userReference", JSON.stringify(res.data))
                store.dispatch({ type: "POPULATE_USER_REFERENCE", payload: res.data })
            })
            .catch(err => {
                //console.log(err)
            })
    }

    getBadgePic = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getEmployeeBadgePic/" + this.props.employee.UserId, AxiosConfig.configValue("min"))
            .then((res) => {
                if (res.data.badgePic[0]) {
                    this.setState({ badgePic: res.data.badgePic[0].imageFullUrl })
                } else {
                    this.setState({ badgePic: null })
                }
            })
            .catch((error: any) => {
                //console.log("error", error);
                AxiosConfig.handleError(error);
            })
    }

    getQR = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getQRPic/" + this.props.employee.UserId, AxiosConfig.configValue("min"))
            .then(res => {
                if (res.data.qrPic.length > 0) {
                    this.setState({ qrPic: res.data.qrPic[0].imageFullUrl })
                }
            })
            .catch(err => {
                //console.log("error", err)
                AxiosConfig.handleError(err)
            })
    }

    getWorkCompIncidents = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/workComp/getWorkCompIncidentList/" + this.props.employee.UserId, AxiosConfig.configValue("min"))
            .then((res) => {
                let claimCount = 0;
                for (let i = 0; i < res.data.length; i++) {
                    if (res.data[i].IncidentStatusTypeDesc === "Open") {
                        claimCount++
                    }
                }
                this.setState({ workComp: res.data, openClaims: claimCount })
            })
            .catch((err) => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }

    getPtOData = () => {
        const currentYearStart: any = moment(new Date().getFullYear(), "YYYY").valueOf()
        const today = Date.now()
        const employee = this.props.employee
        let endpoint = `${process.env.REACT_APP_API_URL}/api/pto/ptodatabyuser/${currentYearStart}/${today}/${employee.Inactive}`
        axios.get(endpoint, AxiosConfig.configValue("min"))
            .then((res) => {
                this.setState({ ledgerEntryTypes: res.data.ledgerEntryTypes, ptoData: res.data.data[0] })
            })
            .catch((err) => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }

    getEmployeeData = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + this.props.employee.UserId, AxiosConfig.configValue())
            .then(res => {
                // //console.log(res.data)
                this.setState({ tabInfo: { WorkCompCount: res.data.users[0].WorkCompCount, EmployeeReviewCount: res.data.users[0].EmployeeReviewCount }, detailedEmployeeData: res.data.users[0] })
                UnalignedHandler.update("a", res.data.users[0].UserId)
            }).catch(err => {
                //console.log(err)
            })
    }

    hasEdits = (hasEdits: boolean) => {
        this.setState({ hasEdits: hasEdits })
    }

    selectLinkText = () => {
        let element = document.getElementById("share-link-popover-form")
        if (element) {
            element.focus()
            //@ts-ignore
            element.select()
        }
    }

    generateShareLink = () => {
        navigator.clipboard.writeText(window.location.href + "/?&UserId=" + this.props.employee.UserId)
        this.manageState([{ key: "showLinkPopover" }])
    }

    copyToClipboard = (str: string | null, snack: string) => {
        if (str) {
            navigator.clipboard.writeText(str)
            snackBar({ text: `${snack} copied to clipboard`, type: "success", timeout: 3000 })
        } else {
            snackBar({ text: "Could not copy to clipboard", type: "error", timeout: 3000 })
        }
    }

    toggleHeaderType = () => {
        if (this.state.headerExpanded === "HeaderExpanded") {
            this.setState({ headerExpanded: "HeaderCollapsed" })
            this.props.setHeaderType("HeaderCollapsed")
        } else {
            this.setState({ headerExpanded: "HeaderExpanded" })
            this.props.setHeaderType("HeaderExpanded")
        }
    }

    toggleFullScreen = () => {
        let overview = document.getElementById("employee-overview")
        if (this.state.viewMode === "EmployeeOverviewFS" && overview) {
            this.setState({ viewMode: "EmployeeOverview" })
            this.props.setViewMode("EmployeeOverview")
            overview.className = "EmployeeOverview"
        } else if (this.state.viewMode === "EmployeeOverview" && overview) {
            this.setState({ viewMode: "EmployeeOverviewFS" })
            this.props.setViewMode("EmployeeOverviewFS")
            overview.className = "EmployeeOverviewFS"
        }
    }


    render() {
        const props = this.props
        const state = this.state
        const employee = props.employee
        const bg = employeeBackground.getBackground(employee)
        let name = "EmployeeOverviewSingleDetailFalse"
        let singleDetail = false
        const ptoDetails = state.ptoData
        if (props.singleDetail) {
            singleDetail = true
        }
        if (singleDetail) {
            name = "EmployeeOverviewSinglDetailTrue"
        }

        const ledgerReference = {
            ledgerEntryTypes: state.ledgerEntryTypes,
            ledgerStatusTypes: []
        }

        // //console.log(props.viewMode)
        // //console.log(bg)
        // //console.log("Edits?", state.hasEdits)
        // //console.log("Secure Edits?", state.hasSecureEdits)
        // //console.log(state.badgePic)
        // //console.log("should allow access? ", shouldAllowAccess("HR:FORMWRITER"))
        // //console.log("(Employee Overview) => employee", employee)
        // //console.log("Overview user settings", msalAuth.UserSettings())

        const shareLinkPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Link has been copied to clipboard.</Popover.Title>
                <FormControl id="share-link-popover-form"
                    placeholder={window.location.href + "/?&UserId=" + props.employee.UserId}
                    aria-describedby="basic-addon1"
                    disabled={false}
                    value={window.location.href + "/?&UserId=" + props.employee.UserId}
                    onChange={() => this.selectLinkText()}
                    onClick={() => this.selectLinkText()}
                />
                <Popover.Content>
                    Paste this link into an email or text message to share this employee detail with another Portal user.
                </Popover.Content>
                <p id="share-employee-url-dismiss-btn" onClick={() => this.manageState([{ key: "showLinkPopover" }])}>Close</p>
            </Popover>
        )

        const OverviewToolTip = (text: string) => (
            <Tooltip id="employee-overview-tool-tip">
                {text}
            </Tooltip>
        )

        return (
            <div className={name}>
                {props.userReference && <div className={state.viewMode} id="employee-overview">
                    {/***************************************************************Header Content******************************************************************/}
                    {!singleDetail && <div>
                        {!state.hasEdits && state.headerExpanded === "HeaderExpanded" &&
                            <div id="employee-overview-close-btn">
                                <p id="employee-overview-close-btn-p" onClick={() => props.closeDetailPanel()}><span className="material-icons">close</span></p>
                            </div>}
                        {state.hasEdits && state.headerExpanded === "HeaderExpanded" && <div id="employee-overview-close-confirm-btn">
                            <p id="employee-overview-close-confirm-btn-p" onClick={() => props.closeDetailPanel()}><span className="material-icons">close</span></p>
                        </div>}
                        {!state.hasEdits && state.headerExpanded === "HeaderCollapsed" && <div id="employee-overview-close-btn-collapsed">
                            <p id="employee-overview-close-btn-p-collapsed" onClick={() => props.closeDetailPanel()}><span className="material-icons">close</span></p>
                        </div>}
                        {state.hasEdits && state.headerExpanded === "HeaderCollapsed" && <div id="employee-overview-close-confirm-btn-collapsed">
                            <p id="employee-overview-close-confirm-btn-p-collapsed" onClick={() => props.closeDetailPanel()}><span className="material-icons">close</span></p>
                        </div>}
                    </div>}
                    {state.headerExpanded === "HeaderExpanded" &&
                        <OverlayTrigger placement="left" overlay={OverviewToolTip("Collapse Header")}>
                            <div id="header-collapse-btn" onClick={() => this.toggleHeaderType()}>
                                <span className="material-icons">unfold_less</span>
                            </div>
                        </OverlayTrigger>}
                    {!singleDetail && <div>
                        {state.headerExpanded === "HeaderExpanded" && state.viewMode === "EmployeeOverview" &&
                            <OverlayTrigger placement="left" overlay={OverviewToolTip("Fit Screen")}>
                                <div id="overview-fullscreen-btn-header-expanded" onClick={() => this.toggleFullScreen()}>
                                    <span className="material-icons">fit_screen</span>
                                </div>
                            </OverlayTrigger>}
                        {state.headerExpanded === "HeaderExpanded" && state.viewMode === "EmployeeOverviewFS" &&
                            <OverlayTrigger placement="left" overlay={OverviewToolTip("Split Screen")}>
                                <div id="overview-fullscreen-btn-header-expanded" onClick={() => this.toggleFullScreen()}>
                                    <span className="material-icons">vertical_split</span>
                                </div>
                            </OverlayTrigger>}

                        {state.headerExpanded === "HeaderCollapsed" && state.viewMode === "EmployeeOverview" &&
                            <OverlayTrigger placement="left" overlay={OverviewToolTip("Fit Screen")}>
                                <div id="overview-fullscreen-btn-header-collapsed" onClick={() => this.toggleFullScreen()}>
                                    <span className="material-icons">fit_screen</span>
                                </div>
                            </OverlayTrigger>}
                        {state.headerExpanded === "HeaderCollapsed" && state.viewMode === "EmployeeOverviewFS" &&
                            <OverlayTrigger placement="left" overlay={OverviewToolTip("Split Screen")}>
                                <div id="overview-fullscreen-btn-header-collapsed" onClick={() => this.toggleFullScreen()}>
                                    <span className="material-icons">vertical_split</span>
                                </div>
                            </OverlayTrigger>}
                    </div>}
                    {state.headerExpanded === "HeaderExpanded" && <div className="EmployeeOverviewHeaderExpanded">
                        <div className="EmployeeOverviewHeaderExpandedLP" /*style={{ boxShadow: bg.shadow }}*/>
                            {state.showLinkPopover && <OverlayTrigger show={true} placement="right" overlay={shareLinkPopover}><div id="share-employee-url-popover"></div></OverlayTrigger>}
                            <div className="EmployeeOverviewHeaderExpandedLPRow">
                                <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={OverviewToolTip(`Name: ${employee.LastName}, ${employee.FirstName}`)}>
                                    <div className="EmployeeOverviewHeaderExpandedLPColumn">
                                        <span className="material-icons">person</span>
                                        <p>{employee.LastName}, {employee.FirstName}</p>
                                    </div>
                                </OverlayTrigger>
                                {!singleDetail && <div id="share-employee-url-button-wrapper-header-expanded" className="EmployeeOverviewHeaderExpandedLPColumn">
                                    <span className="material-icons" onClick={() => this.generateShareLink()}>share</span>
                                    <p onClick={() => this.generateShareLink()}>Link to Employee</p>
                                </div>}
                            </div>
                            <div className="EmployeeOverviewHeaderExpandedLPRow">
                                <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={OverviewToolTip(`Supervisor: ${employee.Supervisor}`)}>
                                    <div className="EmployeeOverviewHeaderExpandedLPColumn">
                                        <span className="material-icons">engineering</span>
                                        <p id="employee-overview-header-expanded-supervisor">{employee.Supervisor}</p>
                                    </div>
                                </OverlayTrigger>
                                <div id="employee-overview-header-expanded-field-finder" className="EmployeeOverviewHeaderExpandedLPColumn">
                                    <FieldFinder
                                        isDropdown={true}
                                        tagName="p"
                                    />
                                </div>
                            </div>
                            <div className="EmployeeOverviewHeaderExpandedLPRow">
                                <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={OverviewToolTip(`Job Title: ${employee.JobTitle}`)}>
                                    <div className="EmployeeOverviewHeaderExpandedLPColumn">
                                        <span className="material-icons">work</span>
                                        <p>{employee.JobTitle}</p>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className="EmployeeOverviewHeaderExpandedLPRow">
                                <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={OverviewToolTip(`Home Profit Center: ${employee.HomeProfitCenter}`)}>
                                    <div className="EmployeeOverviewHeaderExpandedLPColumn">
                                        <span className="material-icons">apartment</span>
                                        <p>{employee.HomeProfitCenter}</p>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className="EmployeeOverviewHeaderExpandedLPRow">
                                <div className="EmployeeOverviewHeaderExpandedLPColumn">
                                    <span className="material-icons">phone</span>
                                    {employee.WorkPhone && reggie.formatPhone(employee.WorkPhone) && <a href={`tel:${employee.WorkPhone}`}>{reggie.formatPhone(employee.WorkPhone)}</a>}
                                    {employee.WorkPhone && !reggie.formatPhone(employee.WorkPhone) && <p>*Invalid Number*</p>}
                                    {!employee.WorkPhone && <p>*NA*</p>}
                                </div>
                                <div className="EmployeeOverviewHeaderExpandedLPColumn" id="unambiguous-emp-number-header-expanded">
                                    <p>{`# ${employee.EmployeeNumber}`}</p>
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={OverviewToolTip("Copy to clipboard")}>
                                        <span className="material-icons" onClick={() => this.copyToClipboard(employee.EmployeeNumber, "Employee Number")}>content_copy</span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                            <div className="EmployeeOverviewHeaderExpandedLPRow">
                                <div className="EmployeeOverviewHeaderExpandedLPColumn">
                                    <span className="material-icons">mail_outline</span>
                                    {employee.WorkEmail && <a href={`mailto:${employee.WorkEmail}`}>{employee.WorkEmail}</a>}
                                    {!employee.WorkEmail && <p>*NA*</p>}
                                </div>
                                <div className="EmployeeOverviewHeaderExpandedLPColumn" id="unambiguous-emp-user-id-header-expanded">
                                    <p>{`ID: ${employee.UserId}`}</p>
                                </div>
                            </div>
                        </div>
                        <div className="EmployeeOverviewHeaderExpandedRP">
                            <div id="r-eop-qr-pic-wrapper">
                                {state.qrPic && <img id="r-eop-qr" src={state.qrPic || ""} alt="" ></img>}
                                {state.badgePic && <img id="r-eop-profile-pic" style={{ boxShadow: bg.shadow }} src={`${state.badgePic}?t=${Date.now()}` || ""} alt="" onClick={() => this.manageState([{ key: "editBadge" }])}></img>}
                                {!state.badgePic && <div id="r-eop-no-badge-pic" style={{ backgroundColor: bg.color }} onClick={() => this.manageState([{ key: "editBadge" }])}>
                                    <p id="r-eop-no-badge-pic-p1" style={{ color: bg.fontColor }}>{bg.firstInitial}</p>
                                    <p id="r-eop-no-badge-pic-p2" style={{ color: bg.fontColor }}>{bg.lastInitial}</p>
                                </div>}
                            </div>
                        </div>
                    </div>}
                    {state.headerExpanded === "HeaderCollapsed" && <div className="EmployeeOverviewHeaderCollapsed">
                        <div className="EmployeeOverviewHeaderCollapsedLP">
                            <div id="employee-overview-lp-header-collapsed-r1">
                                <div id="l-eop-name-collapsed">
                                    <span className="material-icons">person</span>
                                    <p>{employee.LastName}, {employee.FirstName}</p>
                                </div>
                                <div id="l-eop-title-collapsed">
                                    <span className="material-icons">work</span>
                                    <p>{employee.JobTitle}</p>
                                </div>
                                <div id="l-eop-profit-center-collapsed">
                                    <span className="material-icons">apartment</span>
                                    <p>{employee.HomeProfitCenter}</p>
                                </div>
                                <div id="l-eop-unambiguos-emp-number-collapsed">
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={OverviewToolTip("Copy to clipboard")}>
                                        <span className="material-icons" onClick={() => this.copyToClipboard(employee.EmployeeNumber, "Employee Number")}>content_copy</span>
                                    </OverlayTrigger>
                                    <p># {employee.EmployeeNumber}</p>
                                </div>
                            </div>
                            <div id="employee-overview-lp-header-collapsed-r2">
                                <div id="l-eop-phone-collapsed">
                                    <span className="material-icons">phone</span>
                                    {employee.WorkPhone && <a href={`tel:${employee.WorkPhone}`}>{employee.WorkPhone}</a>}
                                    {!employee.WorkPhone && <p>*NA*</p>}
                                </div>
                                <div id="l-eop-mail-collapsed">
                                    <span className="material-icons">mail_outline</span>
                                    {employee.WorkEmail && <a href={`mailto:${employee.WorkEmail}`}>{employee.WorkEmail}</a>}
                                    {!employee.WorkEmail && <p>*NA*</p>}
                                </div>
                                {!singleDetail && <div id="share-employee-url-button-wrapper-collapsed">
                                    <span className="material-icons" onClick={() => this.generateShareLink()}>share</span>
                                    <p onClick={() => this.generateShareLink()}>Link to Employee</p>
                                </div>}
                                {state.showLinkPopover && <OverlayTrigger show={true} placement="right" overlay={shareLinkPopover}><div id="share-employee-url-popover-collapsed"></div></OverlayTrigger>}
                                <div className="EmployeeOverviewFieldFinderWrapperHeaderCollapsed">
                                    <p id="unambiguous-emp-user-id-collapsed">{`ID: ${employee.UserId}`}</p>
                                    <FieldFinder
                                        isDropdown={true}
                                        tagName="p"
                                    />
                                </div>
                            </div>
                            <div className="EmployeeOverviewHeaderCollapsedRP">
                                <div id="r-eop-qr-pic-wrapper-collapsed">
                                    {state.badgePic && <img id="r-eop-profile-pic-collapsed" style={{ boxShadow: bg.shadow }} src={`${state.badgePic}?t=${Date.now()}` || ""} alt="" onClick={() => this.manageState([{ key: "editBadge" }])}></img>}
                                    {!state.badgePic && <div id="r-eop-no-badge-pic-collapsed" style={{ backgroundColor: bg.color }} onClick={() => this.manageState([{ key: "editBadge" }])}>
                                        <p id="r-eop-no-badge-pic-p1-collapsed" style={{ color: bg.fontColor }}>{bg.firstInitial}</p>
                                        <p id="r-eop-no-badge-pic-p2-collapsed" style={{ color: bg.fontColor }}>{bg.lastInitial}</p>
                                    </div>}
                                    {state.headerExpanded === "HeaderCollapsed" &&
                                        <OverlayTrigger placement="left" overlay={OverviewToolTip("Expand Header")}>
                                            <div id="header-expand-btn" onClick={() => this.toggleHeaderType()}>
                                                <span className="material-icons">unfold_more</span>
                                            </div>
                                        </OverlayTrigger>}
                                </div>
                            </div>
                        </div>
                    </div>}
                    <div className={`EmployeeOverviewTabs${state.headerExpanded}`}>
                        {state.editBadge &&
                            <PhotoUploader
                                title={"Add Badge Photo"}
                                toggler={() => this.manageState([{ key: "editBadge" }])}//your function to toggle the uploader on or off
                                photoDex={0}//the length of the array of photos you adding to
                                refresher={() => this.getBadgePic()}
                                hashed={false}
                                multiple={false}
                                requestBody={
                                    {
                                        TimeStamp: Date.now(),
                                        UTCOffset: this.timeZoneOffset,
                                        ClientImageKey: Date.now(),
                                        ImageType: "EmployeeBadgePicture",
                                        QueueStatus: "failed",
                                        EmployeeId: props.employee.UserId,
                                        Orientation: 4,
                                        Descriptor: "Badge",
                                    }
                                }
                            />}
                        {/***************************************************************Tab Content********************************************************************************/}
                        <Tabs defaultActiveKey={props.activeKey} variant={"tabs"} onSelect={this.handleTabSelect}>
                            {/* Tab is visible to: pure viewers, the two writer roles (HR:ADMIN / HR:USER-ADMIN-WRITER),
                                and managers — anyone with Vault77.Read.PayRate can open an in-scope employee's form
                                read-only to view pay. readOnly (below) is what actually gates editing. */}
                            {!singleDetail && props.userReference && (shouldAllowAccess("PORTAL:USER-ADMIN-VIEWER") || shouldAllowAccess("HR:USER-ADMIN-WRITER") || shouldAllowAccess("HR:ADMIN") || shouldAllowAccess("Vault77.Read.PayRate")) &&
                                <Tab eventKey="UserAdministration" title={<EOTabTitle id="eot-user-admin" icon="admin_panel_settings" label={this.adminTitle} />} unmountOnExit={true}>
                                    <UserAdmin
                                        employee={employee}
                                        userId={props.userId}
                                        reference={props.userReference}
                                        hasEdits={this.hasEdits}
                                        employeeBackround={bg}
                                        updadeList={props.updateList}
                                        singleDetail={props.singleDetail}
                                        readOnly={!(shouldAllowAccess("HR:ADMIN") || shouldAllowAccess("HR:USER-ADMIN-WRITER"))}
                                        doublePanelRef={this.props.doublePanelRef}
                                        mangaeParentState={this.manageState}
                                    />
                                </Tab>}
                            {!singleDetail &&
                                <Tab eventKey="Training" title={<EOTabTitle id="eot-training" icon="school" label="Training" />} unmountOnExit={true}>
                                    <Training
                                        targetedUserId={props.employee.UserId}
                                        readOnly={!shouldAllowAccess("HR:TRAINING")}
                                    />
                                </Tab>}
                            {!singleDetail && props.userReference && (shouldAllowAccess("PORTAL:WORK-COMP-VIEWER") || shouldAllowAccess("HR:WORK-COMP-WRITER")) &&
                                <Tab eventKey="WorkersComp" title={<EOTabTitle id="eot-workers-comp" icon="personal_injury" label={<p id="workers-comp-claim-count">Workers Comp ({state.openClaims})</p>} />} unmountOnExit={true}>
                                    <WorkersComp
                                        employee={employee}
                                        userId={props.userId}
                                        workersCompItems={state.workComp}
                                        refresh={this.getWorkCompIncidents}
                                        hasEdits={this.hasEdits}
                                        isDirty={state.hasEdits}
                                        //@ts-ignore
                                        reference={props.userReference}
                                        readOnly={shouldAllowAccess("HR:WORK-COMP-WRITER")}
                                    />
                                </Tab>}
                            {!singleDetail && (shouldAllowAccess("PORTAL:REVIEW-VIEWER") || shouldAllowAccess("HR:REVIEW-WRITER")) &&
                                <Tab eventKey="Reviews" title={<EOTabTitle id="eot-workers-comp" icon="grading" label={<p id="workers-comp-claim-count">Reviews ({state.tabInfo.EmployeeReviewCount})</p>} />} unmountOnExit={true}>
                                    <div className={`EmployeeOverviewReviewWrapper${state.headerExpanded}`}>
                                        <Reviews
                                            contextUser={props.userId}
                                            employee={props.employee}
                                            doublePanelRef={props.doublePanelRef}
                                            updateEmployee={this.getEmployeeData}
                                            detailedEmployeeData={state.detailedEmployeeData}
                                            readOnly={shouldAllowAccess("HR:REVIEW-WRITER")}
                                            isDelegation={false}
                                            delegatorEmployeeId={-1}
                                        />
                                    </div>
                                </Tab>}
                            {singleDetail && ptoDetails &&
                                <Tab eventKey="Pto" active={true} title={<EOTabTitle id="eot-user-admin" icon="access_time" label="PTO" />} unmountOnExit={true}>
                                    <div className="EmployeeOverviewPtoWrapper">
                                        <ManageDetail
                                            ledgerReference={ledgerReference}
                                            handleClose={() => null}
                                            details={ptoDetails}
                                            updateTable={() => null}
                                            hideHeader={true}
                                            toggleVertical={() => null}
                                            isVertical={false}
                                        />
                                    </div>
                                </Tab>}
                            {!singleDetail && (shouldAllowAccess("HR:PTO") || shouldAllowAccess("COOP:PTO")) &&
                                <Tab eventKey="Pto" title={<EOTabTitle id="eot-user-admin" icon="access_time" label="PTO" />} unmountOnExit={true}>
                                    <div className="EmployeeOverviewPtoWrapper">
                                        {state.ptoData && <PTODecoupler
                                            EmployeeID={props.employee.UserId}
                                        />}
                                    </div>
                                </Tab>}
                            {!singleDetail && shouldAllowAccess("HR:FORM-DOWNLOADER") &&
                                <Tab eventKey="CompletedForms" title={<EOTabTitle id="eot-user-admin" icon="task" label="Tasks" />} unmountOnExit={true}>
                                    <div className="EmployeeOverviewCompletedFormsWrapper">
                                        <TaskManager
                                            targetedUserId={props.employee.UserId}
                                        />
                                    </div>
                                </Tab>}
                            {!singleDetail && (shouldAllowAccess("IT:ROLEASSIGNMENT") || shouldAllowAccess("PortalAdmin")) &&
                                <Tab eventKey="Roles" title={<EOTabTitle id="eot-user-roles" icon="admin_panel_settings" label="Roles" />} unmountOnExit={true}>
                                    <RoleAssignment
                                        targetedUserId={props.employee.UserId}
                                    />
                                </Tab>}
                            {!singleDetail && shouldAllowAccess("HR:EmployeeAccessLevel") &&
                                <Tab eventKey="EmployeeAccessLevel" title={<EOTabTitle id="eot-employee-access-level" icon="lock" label="User Access" />} unmountOnExit={true}>
                                    <div className="EmployeeOverviewEmployeeAccessLevelWrapper">
                                        <EALA
                                            targetUserId={props.employee.UserId}
                                        />
                                    </div>
                                </Tab>}
                        </Tabs>
                    </div>
                    <Naggy
                        disabledElements={["double-panel-table", "employee-filter-wrapper", "employee-overview-close-confirm-btn-p-collapsed", "employee-overview-close-confirm-btn-p", "open-employee-search-options", "add-employee-btn"]}
                        isDirty={state.hasEdits}
                        toggleDirty={this.hasEdits}
                        discard={props.closeDetailPanel}
                        message={this.discardMsg}
                        cancleSecureSesion={true}
                    />
                </div>}
                {!props.userReference && <div className="WaitingForReferenceDataEmployeeOverview">
                    <span className="material-icons">autorenew</span>
                    <p>Caching reference data</p>
                </div>}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    userReference: state.userReference.userReference
})

export default connect(mapStateToProps)(EmployeeOverview)